// Add your custom JS here.

jQuery(function($){
    $(".elementor-location-header + div").addClass('site-container');

    if($.cookie('accessibility') == 1){
        $("body").addClass("accessibility");
    }

    $('a[href="#toggle-accessibility"]').on('click', function(e){
        console.log('toggle-accessibility');
        e.preventDefault();
        $("body").toggleClass("accessibility");
        if( $("body").hasClass("accessibility") ){
            $.cookie('accessibility', 1);
        }else{
            $.cookie('accessibility', 0);
        }
        e.stopPropagation();
    });



    // widget infeau loisirs
    $("input[data-parent]").on("change", function(e){
        let elt = $(this);
        if($("input[data-parent='"+elt.data('parent')+"']:checked").length > 0){
            $("input#"+elt.data('parent')).prop('checked', true);
        }else{
            $("input#"+elt.data('parent')).prop('checked', false);
        }
    });
    $('#generate_widget').on("submit", function(e) {
        e.preventDefault();
    })

    let rivers_ids = [];
    $('#generate_widget input').on("change", function(e) {
        e.preventDefault();
        rivers_ids = $("#generate_widget").serialize();

        //$("#preview_link").attr("href","?"+decodeURI(rivers_ids));

        let before = '<iframe width="100%" height="330px" frameborder="0" src="'+theme_vars.home_url+'/widget-infeau-loisir/?';
        let after = '"></iframe>';

        $("#widget_code").val(before+decodeURI(rivers_ids)+after);
        $("#preview_zone iframe").on('load', function(e){
            console.log("loaded iframe");
        });
    });

    if($("#preview_link").length > 0){
        console.log("binding preview link");

        $("#preview_link").on("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            $("#preview_zone").html($("#widget_code").val());

            console.log("preview link clicked");

        });

    }



    // gestion explorateur de fichiers
    if($(".nc-folder-container").length > 0){
        window.addEventListener("hashchange", () => {

            let hash = location.hash;
            let folder_id = hash.replace("#nc-folder-", "");

            let root_folder_id = $(".nc-folder-container").data('nc-folder');
            let url = theme_vars.ajax_url;
            $(".nc-folder-container").addClass('loading');
            $.ajax({
                url: url,
                method: "POST",
                data:{
                    action: "nc_folder",
                    folder_id:folder_id,
                    root_folder_id:root_folder_id,
                },
                success: function(data){
                    $(".nc-folder-container").html(data);
                },
                complete:function () {
                    $(".nc-folder-container").removeClass('loading');
                }
            });
        });

    }



    // gestion cartes
    let  mapContainers = $(".map-container");
    window.currentMarkers = [];

    mapContainers.each(function(i,e){
        mapboxgl.accessToken = theme_vars.clef_mapbox;
        let  mapContainer = $(e).find('.map');
        console.log("mapContainer", mapContainer);
        if(mapContainer.length){


            let lat = mapContainer.data("lat");
            let lng = mapContainer.data("lng");
            let position = [];
            if(lat && lng){
                position = [lat, lng];
            }else{
                position = [1.2978742, 44.5596581] ;
            }


            let map = new mapboxgl.Map({
                container: mapContainer.attr('id'),
                //style: 'mapbox://styles/mapbox/streets-v11',
                style: 'mapbox://styles/periwinkle/cmfp7tzvv007e01se9gikdmhf',
                center: position,
                zoom: mapContainer.data("zoom")?mapContainer.data("zoom") : 11,
                cooperativeGestures: true,
                scrollZoom: true

            });
            // modif du 13/02/2026 ajout du passage en fullscreen
            map.addControl(new mapboxgl.FullscreenControl());

            $(function(){
                window.setTimeout(function(){
                    map.resize();
                    console.log("triggerresize");
                },1000);
                $(window).on('load', function(){
                    console.log("body.load");
                    map.resize();
                })

            });

            let layerList = document.getElementById('map-menu');
            if(layerList){
                const inputs = layerList.getElementsByTagName('input');
                for (const input of inputs) {
                    input.onclick = (layer) => {
                        const layerId = layer.target.value;
                        map.setStyle(layerId);
                    };
                }
            }


            let nav = new mapboxgl.NavigationControl();
            map.addControl(nav, 'top-right');

            map.on("wheel", event => {
                if (event.originalEvent.ctrlKey) {
                    return;
                }
                if (event.originalEvent.metaKey) {
                    return;
                }
                if (event.originalEvent.altKey) {
                    return;
                }
                event.preventDefault();
            });

            /*map.on('drag ', event => {
                console.warn(event);
            });*/

            let bounds = new mapboxgl.LngLatBounds();
            //window.map = map;
            //window.bounds = bounds;

            let filter = $(e).find(".map-filter");
            //console.log("filter : ", filter);

            if (filter.length > 0 ) {

                filter.find("input").on("change", function (e) {
                    //let filters = filter.find("input").serializeArray();
                    let container = $(this).parent().parent().toggleClass("selected");
                    let filters = filter.find('input:checkbox:checked').map(function() {
                        return String($(this).val());
                    }).get();
                    //console.log("Filter : ",filters);
                    if(filters.length > 0){
                        // masquer tout sauf
                        for (let m in map.customMarkers){
                            //console.log(map.customMarkers[m]);
                            let marker = map.customMarkers[m];
                            marker.remove();
                            if(typeof marker.popup != "undefined"){
                                //console.log("Popup : ",marker.popup)
                                marker.popup.remove();
                            }
                        }

                        // afficher ce qui est coché
                        for (let m in map.customMarkers){
                            let marker = map.customMarkers[m];
                            /*console.log("filter : ", filters);
                            console.log("type : ", marker.type);*/

                            if(filters.includes(String(marker.type))){
                                marker.addTo(map);
                            }
                           // marker.addTo(map);
                        }

                    }else{
                        // afficher tout
                        for (let m in map.customMarkers){
                            let marker = map.customMarkers[m];
                            marker.addTo(map);
                        }
                    }
                });
            }
        pwk_configureMarkers(map, bounds);
        }

    });



    let currentMarkerPopup = null;
    let currentMarkerPopupSmall = null;

    //pwk_configureMarkers(map);


    /*mapContainers.each(function(i,e) {
        let mapContainer = $(e);
        console.log("mapContainer", mapContainer);
        if (mapContainer.length) {
            // gestion filtre
            let filter = mapContainer.find(".map-filter");
            if (filter.length > 0) {
                console.log("filter");
                filter.find("input").on("change", function (e) {
                    let filters = filter.find("input").serializeArray();
                    console.log(filters);
                    if(filters.length > 0){
                        // masquer tout sauf

                        // afficher ce qui est coché

                    }else{
                        // afficher tout
                    }
                });
            }
        }
    });*/

    function loadMarkersInner(map, features) {
        let markers = [];
        let popup = new mapboxgl.Popup({
            offset: [0, -35],
            closeButton: true,
            closeOnClick: false,
            focusAfterOpen: true,
            autoPan: true,
            maxWidth:"400px"
        });
        /*let popupSmall = new mapboxgl.Popup({
            offset: [0, -35],
            closeButton: false,
            closeOnClick: false
        });*/
        currentMarkerPopup = popup;
        //currentMarkerPopupSmall = popupSmall;

        for (let marker in window.currentMarkers) {
            //console.log("Marker : "+marker, map._markers[marker])
            // modif du 14/01/2026 ne pas remove les markers
            //window.currentMarkers[marker].remove();
        }

        if (features.length > 0) {
            var bounds = new mapboxgl.LngLatBounds();

            for (let i in features) {
                //console.log(features[i]);
                let datas = features[i];

                //const marker = new mapboxgl.Marker({"color" : datas.properties['marker-color']}); // sans icône

                const marker = new FontawesomeMarker({
                    icon: datas.properties["icon"] ? "fas " + datas.properties["icon"] : 'fas fa-circle',
                    iconColor: '#ffffff',

                    color: datas.properties["marker-color"] ? datas.properties["marker-color"] : '#aaaaaa'
                }); // avec icône
                marker.type = datas.properties["type"];
                marker
                    .setLngLat(datas.geometry.coordinates)
                    //.setPopup(new mapboxgl.Popup({ offset: 25 }).setHTML(`<h3><a href="`+datas.properties['link']+`">`+datas.properties['title']+`</a></h3>`))
                    //.setPopup(new mapboxgl.Popup({ offset: 5 }).setHTML(datas.properties['allContent']))
                    .addTo(map);

                //elRect = new mapboxgl.LngLat(datas.geometry.coordinates.lng, datas.geometry.coordinates.lat)
                bounds.extend(datas.geometry.coordinates);
                markers.push(marker);
                let markerElement = marker.getElement();

                markerElement.addEventListener('mouseenter', (e) => {
                    map.getCanvas().style.cursor = 'pointer';
                    popup
                        .setLngLat(datas.geometry.coordinates)
                        .setHTML('<div class="marker-pop">' + datas.properties['title'] + `</div>`)
                        //.setHTML(datas.properties['allContent'])
                        .addTo(map);

                    marker.popup = popup;

                    //console.log("mouseenter",e);
                });

                markerElement.addEventListener('mouseleave', (e) => {
                    //alert("mouseleave");
                    //console.log("mouseleave",e);
                    map.getCanvas().style.cursor = '';
                    //popup.remove();
                });

                markerElement.addEventListener('click', (e) => {
                    console.log("click", datas.geometry.coordinates);

                    /*map.panTo(datas.geometry.coordinates,{duration: 0});
                    const bounds = map.getBounds();
                    map.panTo([datas.geometry.coordinates[0], bounds.getNorth()]);*/
                    let thumb = datas.properties['thumbnail'] ? '<div class="marker-pop"><img src="' + datas.properties['thumbnail'] + '" class="img-fluig"></div>' : "";
                    //map.getCanvas().style.cursor = 'pointer';
                    popup
                        //.setLngLat(datas.geometry.coordinates)
                        //.setHTML('<div class="marker-pop">' + thumb + `<h3>` + datas.properties['title'] + `</h3>` + ` <a href="` + datas.properties['link'] + `" class="btn btn-primary btn-sm" target="_top">Plus d'infos</a></div>`)

                        .setHTML('<div class="marker-pop">' + thumb + datas.properties['content-html']+`</div>`)

                        //.setHTML('<div class="marker-pop">'+thumb+`<h3>`+datas.properties['title']+`</h3>`+`</div>`)
                        //.setHTML(datas.properties['title'])
                        .addTo(map);



                });

                /*markerElement.addEventListener('click', (e) => {
                    window.location.href = datas.properties['link'];
                    //console.log("mouseenter",e);
                });*/

                window.currentMarkers.push(marker);

            }
            if (features.length > 1) {
                /*if ($("#map").data("zoom") || $("#map").data("lat")) {
                    // on ne fait rien
                } else {
                    // sinon on fit

                }*/
                map.fitBounds(bounds, {padding: 50});

            } else {
                let datas = features[0];
                map.setCenter(datas.geometry.coordinates);
                map.setZoom(13)
            }
            map.customMarkers = markers;

        }
    }

    function loadMarkers(map, features){

        if(!map.isStyleLoaded()){
            //console.log("isStyleLoaded NOK", map);
            map.on('load', function(e){
                loadMarkersInner(map, features);
                //console.log("isStyleLoaded NOK bis", map);
            });
        }else{
            loadMarkersInner(map, features);
            //console.log("isStyleLoaded OK");
        }
    }

    function pwk_configureMarkers(map, bounds){
        let container = $(map._container);
        if(container.parent().find(".marker-data").length > 0){
            let features = [];
            //console.log("container ",map._container);
            //console.log("container elt ",container);
            //console.log("container markers ",container.parent().find(".marker-data"));
            container.parent().find(".marker-data").each(function (i,e){
                var el = $(e);

                var color = el.data('color');
                var id = el.data('id');
                var lat = el.data('lat');
                var lng = el.data('lng');
                var type = el.data('type');
                var title = el.data('title');
                var link = el.data('link');
                var thumbnail = el.data('thumbnail');
                var icon = el.data('icon');
                var allContent = el.html();
                /*let markerMap = new mapboxgl.Marker({color:color})
                    .setLngLat([lng, lat])
                    .addClassName(type)
                    .setPopup(new mapboxgl.Popup({ offset: 25, closeOnClick:false, closeButton:false, maxWidth:"200px" }).setHTML('<p><h3>'+title+'</h3></p>'))
                    .addTo(window.map);
                console.log("markerMap", markerMap);*/

                let feature = {
                    // feature for Mapbox DC
                    'type': 'Feature',
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            lng, lat
                        ]
                    },
                    'properties': {
                        'title': title,
                        'link': link,
                        'icon': icon,
                        "marker-color":color,
                        "id" : id,
                        "type" : type,
                        "thumbnail" : thumbnail,
                        "content-html" : allContent
                    }
                }
                features.push(feature);


                /*markerMap.on('hover', function(e){
                    console.log("Hover on ", e)
                })*/
                /*window.*/
                bounds.extend(new mapboxgl.LngLat(lng, lat));
                el.removeClass("marker-data").addClass("marker-data-done");
            });

            loadMarkers(map, features);


        }
    }


    $(".search-syndic-collecte").each(function(){
        let block = $(this);
        let input = block.find(".search-commune");
        $( input ).autocomplete({

            source: function( request, response ) {
                $('.collapse_syndic').collapse('hide');
                $.ajax( {
                    url: input.data('url'),
                    dataType: "json",
                    data: {
                        "action" :"autocomplete_commune",
                        "term": request.term
                    },
                    success: function( data ) {
                        response( data );
                    }
                } );
            },
            minLength: 2,
            select: function( event, ui ) {

                for ( let i in ui.item.syndicat) {

                    $('#container_syndic_'+ui.item.syndicat[i]).collapse('show');
                }

            }
        } );
    });




    $("form.form-tri select.dechet").change(function(e){
        var destinations = $(this).find(':selected').data('destination');

        if(destinations){
            destinations = destinations.split(/ +/);
            $("ul.destinations-dechet li").hide(250);
            $.each(destinations,function(i,e){
                $("ul.destinations-dechet li#"+e).show(250);
            });
        }

    });

    var index = Math.floor(Math.random() * $("form.form-tri select.dechet > option").length) + 1;
    $("form.form-tri select.dechet option:nth-child(" + index + ")").prop("selected", true);
    $("form.form-tri select.dechet").trigger("change");
    $("form.form-tri .invisible").removeClass("invisible");

    $('form.form-tri select.dechet').select2({
        language: {
            noResults: function() {
                return "Pas de résultat";
            }
        }
    });




    $('.slider').each(function (i,e){
        let elt = $(e);
        let slider = elt.lightSlider({
            item:5,
            loop:false,
            slideMove:1,
            easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
            speed:600,
            enableTouch: true,
            enableDrag: true,
            adaptiveHeight: false,
            onSliderLoad: function() {
                $('.slider').removeClass('cS-hidden');
            },
            responsive : [
                {
                    breakpoint:800,
                    settings: {
                        item:3,
                        slideMove:1,
                        slideMargin:0,
                    }
                },
                {
                    breakpoint:480,
                    settings: {
                        item:2,
                        slideMove:1
                    }
                },
                {
                    breakpoint:400,
                    settings: {
                        item:1,
                        slideMove:1
                    }
                }
            ]
        });

        elt.parent().parent().parent().parent().find('.fa-caret-left').on('click', function(){
            slider.goToPrevSlide();

        });
        elt.parent().parent().parent().parent().find('.fa-caret-right').on('click', function(){
            slider.goToNextSlide();
        });








    });




    $('.slider-small').each(function (i,e){
        let elt = $(e);
        let slider = elt.lightSlider({
            item:5,
            loop:false,
            slideMove:1,
            easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
            speed:600,
            enableTouch: true,
            enableDrag: true,
            adaptiveHeight: false,
            onSliderLoad: function() {
                $('.slider-small').removeClass('cS-hidden');
            },
            responsive : [
                {
                    breakpoint:968,
                    settings: {
                        item:3,
                        slideMove:1,
                        slideMargin:0,
                    }
                },
                {
                    breakpoint:600,
                    settings: {
                        item:2,
                        slideMove:1
                    }
                },
                {
                    breakpoint:400,
                    settings: {
                        item:1,
                        slideMove:1
                    }
                }
            ]
        });

        elt.parent().parent().parent().parent().find('.fa-caret-left').on('click', function(){
            slider.goToPrevSlide();

        });
        elt.parent().parent().parent().parent().find('.fa-caret-right').on('click', function(){
            slider.goToNextSlide();
        });


        const myCollapsible = document.getElementById('accordionInfeaLoisir')
        myCollapsible.addEventListener('shown.bs.collapse', event => {
            console.log("refresh")
            slider.refresh();

        })

        const myCollapsibleToday = document.getElementById('accordionInfeaLoisirToday')
        myCollapsibleToday.addEventListener('shown.bs.collapse', event => {
            console.log("refresh today")
            slider.refresh();
        })

        const myCollapsibleTendances = document.getElementById('accordionInfeaLoisirTendance')
        myCollapsibleTendances.addEventListener('shown.bs.collapse', event => {
            console.log("refresh myCollapsibleTendances")
            slider.refresh();
        });

        const tabToday = document.querySelector('#aujourdhui-tab');
        tabToday.addEventListener('shown.bs.tab', event => {
            console.log("refresh tabToday")
            slider.refresh();

        });
        const tabTendances = document.querySelector('#demain-tab');
        tabTendances.addEventListener('shown.bs.tab', event => {
            console.log("refresh myCollapsibleTendances")
            slider.refresh();

        });

    });


});


